import { Component } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/SidebarPopup.styl'
import * as cn from 'classnames'
import { BlockCorners } from 'interfaces/component'
import { SidebarPopupBase } from 'components/features/pfm/SidebarPopup/SidebarPopupBase'

export type SidebarPopupProps = {
  corners: BlockCorners
  hidePopupTimeoutId: number | null
  onRegisterHideTimeout: (timeoutId: number) => void
  onHidePopup: () => void
  stretchHeight?: boolean
}

export class SidebarPopup extends Component<SidebarPopupProps> {
  render () {
    const {
      corners, stretchHeight,
      hidePopupTimeoutId, onRegisterHideTimeout, onHidePopup,
      children,
    } = this.props

    const popupClassName = cn(styles.popup, {
      [styles.allCorners]: corners === 'all',
      [styles.rightCorners]: corners === 'right',
      [styles.stretchHeight]: stretchHeight,
    })

    return (
      <SidebarPopupBase
        hidePopupTimeoutId={ hidePopupTimeoutId }
        onRegisterHideTimeout={ onRegisterHideTimeout }
        onHidePopup={ onHidePopup }
        className={ popupClassName }
      >
        { children }
      </SidebarPopupBase>
    )
  }
}
